import { Box, Button, Select, VStack } from "components/ui";
import SwitchFilter from "components/ui/SwitchFilter";
import { Typography } from "components/ui/Typography";
import React from "react";

import { SignedIn } from "components/clerk";
import { useRouter } from "expo-router";
import { ItemCategoryRead, ItemSubCategoryRead } from "store/abcoApi";
import { useFilterSettings } from "utils/hooks/useFilterSettings";

type Props = {
	category: ItemCategoryRead;
	subCategory: ItemSubCategoryRead | null;
	onChange?: (value: any) => void;
};

const ItemFilterList = ({ category, subCategory, onChange }: Props) => {
	const [filterState, setFilterState] = React.useState({});
	const [isCore, setIsCore] = React.useState(false);
	const [inStock, setInStock] = React.useState(false);
	const [isApprovedItem, setIsApprovedItem] = React.useState(false);
	const { isFilterSettingsOpen, setIsFilterOpen } = useFilterSettings();
	const router = useRouter();

	function onCategoryChange(value: any) {
		if (value != null) {
			router.push(`${category.url}/${value}`);
		}
	}

	function setFilterValue(key: string, value: any) {
		const newState = {
			...filterState,
			[key]: value,
		};
		setFilterState(newState);
		if (onChange) {
			onChange(newState);
		}
	}

	function clearAllFilters() {
		const newState = {
			isCore: false,
			inStock: false,
			isApprovedItem: false,
		};
		setFilterState(newState);
		setIsCore(false);
		setInStock(false);
		setIsApprovedItem(false);
		if (onChange) {
			onChange(newState);
		}
	}

	function renderCategoryDropdown() {
		if (category == null || category.subCategoryCollection == null || category.subCategoryCollection.length == 0 || subCategory == null) {
			return;
		}

		const options =
			category.subCategoryCollection?.map((item: ItemSubCategoryRead) => ({
				label: item.name,
				value: item.slug,
			})) || [];

		const selected = options.find((option) => option.value === subCategory?.slug) || options[0];

		return (
			<Box paddingBottom={32} zIndex={1}>
				<Select label={category.name ?? ""} onChange={onCategoryChange} options={options} value={selected} defaultValue={selected} isClearable={false} />
			</Box>
		);
	}

	return (
		<Box>
			{/* <Button
				onPress={() => {
					setIsFilterOpen(!isFilterSettingsOpen);
				}}
				alignSelf="flex-start"
				alignItems="center"
				gap={8}
			>
				<Text color="$primarylight">Hide/show filter</Text>
				<Icon as={isFilterSettingsOpen ? ChevronDown : ChevronRight} color="$primarylight" />
			</Button> */}

			{isFilterSettingsOpen && (
				<Box
					sx={{
						// position: "sticky",
						top: 28,
						zIndex: 100,
						// backgroundColor: "$basicwhite",
						borderBottomWidth: 1,
						borderColor: "$neutral100",
					}}
					// display={isFilterOpen ? "flex" : "none"}
				>
					{renderCategoryDropdown()}
					<Box borderRadius={12} paddingHorizontal={12} paddingVertical={16} bg="$basicwhite">
						<Box flexDirection="column">
							<Button flexDirection="row" alignItems="flex-end" onPress={clearAllFilters}>
								<Typography
									sx={{
										color: "$primarylight",
										marginLeft: "auto",
									}}
								>
									Clear all
								</Typography>
							</Button>
							<VStack paddingVertical={16}>
								<SwitchFilter
									text="Is core?"
									toolTip="Priority stock items"
									value={isCore}
									onChange={(value) => {
										setIsCore(value);
										setFilterValue("isCore", value);
									}}
								/>
								<SwitchFilter
									text="In stock?"
									value={inStock}
									onChange={(value) => {
										setInStock(value);
										setFilterValue("inStock", value);
									}}
								/>
								<SignedIn>
									<SwitchFilter
										text="On approved stocklist"
										value={isApprovedItem}
										onChange={(value) => {
											setIsApprovedItem(value);
											setFilterValue("isApprovedItem", value);
										}}
									/>
								</SignedIn>
								{/* <SwitchFilter text="Show offers" /> */}
								{/* <SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem /> */}
							</VStack>
						</Box>
						{/* <Box flexDirection="column">
							<Box flexDirection="row" alignItems="flex-end">
								<Accordion m={0} type="single" isCollapsible={true} isDisabled={false}>
									<AccordionItem value={"a"} borderColor="$neutral100">
										<AccordionHeader>
											<AccordionTrigger paddingHorizontal={0}>
												{({ isExpanded }) => {
													return (
														<>
															<Typography.H3
																sx={{
																	textAlign: "left",
																}}
															>
																Advanced Filters
															</Typography.H3>
															{isExpanded ? (
																<Typography
																	sx={{
																		color: "$primarylight",
																		marginLeft: "auto",
																		pointerEvents: "none",
																	}}
																>
																	Hide
																</Typography>
															) : (
																<Typography
																	sx={{
																		color: "$primarylight",
																		marginLeft: "auto",
																		pointerEvents: "none",
																	}}
																>
																	Show
																</Typography>
															)}
														</>
													);
												}}
											</AccordionTrigger>
										</AccordionHeader>
										<AccordionContent>
											<VStack paddingVertical={16}>
												<Typography.H5>ESG Benefits</Typography.H5>
												<Divider bgColor="$neutral100" mt={14} />
												<SwitchFilter text="Is core?" toolTip="This is the core" />
												<SwitchFilter text="In stock?" />
												<SwitchFilter text="On approved stocklist" />
												<SwitchFilter text="Show offers" />
												<SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem />

												<DropdownFilter title="Recycled content percentage">
													<SwitchFilter text="Show offers" />
													<SwitchFilter text="On approved stocklist" />
													<SwitchFilter text="Show offers" />
													<SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem />
												</DropdownFilter>
												<Typography.H5 sx={{ marginTop: 12 }}>Attributes</Typography.H5>
												<DropdownFilter title="Price">
													<SwitchFilter text="Show offers" />
													<SwitchFilter text="On approved stocklist" />
													<SwitchFilter text="Show offers" />
													<SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem />
												</DropdownFilter>
												<DropdownFilter title="Brand">
													<SwitchFilter text="Show offers" />
													<SwitchFilter text="On approved stocklist" />
													<SwitchFilter text="Show offers" />
													<SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem />
												</DropdownFilter>
												<DropdownFilter title="Texture">
													<SwitchFilter text="Show offers" />
													<SwitchFilter text="On approved stocklist" />
													<SwitchFilter text="Show offers" />
													<SwitchFilter text="Has ESG benefits" defaultValue={true} isLastItem />
												</DropdownFilter>
											</VStack>
										</AccordionContent>
									</AccordionItem>
								</Accordion>
							</Box>
						</Box> */}
					</Box>
				</Box>
			)}
		</Box>
	);
};

export default ItemFilterList;
